import Vue from 'vue'
import VueIziToast from 'vue-izitoast'
Vue.use(VueIziToast)
